/**
 * @generated SignedSource<<972e37cbea955eae7208266d1a85dd27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmbedModuleRendererQuery$variables = {
  renderImage?: boolean | null;
  service: string;
  source: string;
};
export type EmbedModuleRendererQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EmbedModuleEditorContainer_query">;
};
export type EmbedModuleRendererQuery = {
  response: EmbedModuleRendererQuery$data;
  variables: EmbedModuleRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "renderImage"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "service"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "source"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmbedModuleRendererQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "EmbedModuleEditorContainer_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EmbedModuleRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "renderImage",
            "variableName": "renderImage"
          },
          {
            "kind": "Variable",
            "name": "service",
            "variableName": "service"
          },
          {
            "kind": "Variable",
            "name": "source",
            "variableName": "source"
          }
        ],
        "concreteType": "Embed",
        "kind": "LinkedField",
        "name": "embed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "service",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmbedImage",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "base64Data",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "width",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0cd99e8fc8ff63c182232d36b4a0db40",
    "id": null,
    "metadata": {},
    "name": "EmbedModuleRendererQuery",
    "operationKind": "query",
    "text": "query EmbedModuleRendererQuery(\n  $service: String!\n  $source: String!\n  $renderImage: Boolean\n) {\n  ...EmbedModuleEditorContainer_query\n}\n\nfragment EmbedModuleEditorContainer_query on Query {\n  embed(service: $service, source: $source, renderImage: $renderImage) {\n    service\n    url\n    source\n    image {\n      url\n      base64Data\n      width\n      height\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ad52c81ca1d0beb4f6a45598c3748f01";

export default node;
